export let HOST = "http://localhost:4000";
if (window.location.host.includes("khotiennamsinh")) {
  HOST = "https://api.khotiennamsinh.com";
}